
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'RecipeCategories',

  async fetch() {
    if (!this.recipeCategories?.length > 0) {
      const { data } = await this.$wp.recipeCategories();
      this.setRecipeCategories(data);
    }
  },

  computed: {
    ...mapState(['recipeCategories']),
  },

  methods: {
    ...mapMutations(['setRecipeCategories']),
  },
};
